var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetstarted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 654,
    viewBox: "0 0 768 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H768V604C768 631.614 745.614 654 718 654H0V0Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 653.78H277.97C277.59 613.37 232.41 574.38 180.1 574.57C178.1 538.66 142.98 504.45 96.48 516.45C80.79 481.24 42.11 454.16 0 455.02V653.78Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8878 653.742C45.0184 653.755 45.1491 653.768 45.28 653.78H219.47C218.91 631.28 185.07 609.01 148 609.01C132.22 572.12 100.78 562.09 60.28 569.4C46.17 538.37 15.98 534.48 0 534.77V604C0 629.888 19.675 651.181 44.8878 653.742Z",
    fill: "#E0DEF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M634.574 292.959H549.571V352.809H634.574V292.959Z",
    fill: "#E0DEF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M625.251 365.916L619.49 361.773L613.729 365.916V344.349H625.251V365.916Z",
    fill: "#918ADF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M619.49 352.131C624.15 352.131 627.927 348.228 627.927 343.414C627.927 338.599 624.15 334.696 619.49 334.696C614.83 334.696 611.052 338.599 611.052 343.414C611.052 348.228 614.83 352.131 619.49 352.131Z",
    fill: "#918ADF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M627.831 343.502C628.578 338.749 625.454 334.271 620.854 333.5C616.254 332.729 611.92 335.956 611.173 340.709C610.427 345.461 613.551 349.939 618.151 350.71C622.75 351.481 627.085 348.254 627.831 343.502Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M625.46 342.107C625.46 345.51 622.783 348.275 619.49 348.275C616.196 348.275 613.52 345.51 613.52 342.107C613.52 338.705 616.196 335.939 619.49 335.939C622.783 335.939 625.46 338.705 625.46 342.107Z",
    stroke: "#E0DEF6",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M556.407 313.581H625.46",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M575.083 308.04H606.784",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M556.407 319.122H625.46",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M556.407 324.662H625.46",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M556.407 330.203H625.46",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M576.108 335.744H605.749",
    stroke: "#918ADF",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M597.59 388.851H583.859V457.305H597.59V388.851Z",
    fill: "#6258D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M580.854 401.495H567.123V457.316H580.854V401.495Z",
    fill: "#E0DEF6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M564.128 393.98H550.397V457.316H564.128V393.98Z",
    fill: "#D0CDF1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M547.392 422.395H533.661V457.316H547.392V422.395Z",
    fill: "#918ADF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M530.666 438.719H516.935V457.305H530.666V438.719Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M605.092 460.934H513.881V386.589",
    stroke: "white",
    strokeWidth: 1.1497,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M590.177 186.108C564.626 186.108 543.91 207.511 543.91 233.91C543.91 260.309 564.626 281.712 590.177 281.712C615.729 281.712 636.445 260.309 636.445 233.91C636.445 207.501 615.729 186.108 590.177 186.108ZM590.177 273.756C568.874 273.756 551.601 255.91 551.601 233.9C551.601 211.891 568.874 194.045 590.177 194.045C611.48 194.045 628.753 211.891 628.753 233.9C628.743 255.92 611.48 273.756 590.177 273.756Z",
    fill: "#E0DEF6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M591.769 199.041C591.769 200.12 590.923 200.983 589.889 200.983C588.854 200.983 588.008 200.11 588.008 199.041C588.008 197.961 588.854 197.098 589.889 197.098C590.923 197.098 591.769 197.961 591.769 199.041Z",
    fill: "#E0DEF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M591.769 268.77C591.769 269.849 590.923 270.713 589.889 270.713C588.854 270.713 588.008 269.839 588.008 268.77C588.008 267.691 588.854 266.827 589.889 266.827C590.923 266.827 591.769 267.701 591.769 268.77Z",
    fill: "#E0DEF6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M574.715 202.834C575.232 203.769 574.924 204.952 574.028 205.496C573.123 206.031 571.979 205.712 571.451 204.787C570.934 203.852 571.242 202.669 572.138 202.125C573.043 201.59 574.187 201.909 574.715 202.834Z",
    fill: "#E0DEF6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M608.455 263.228C608.973 264.164 608.664 265.346 607.769 265.891C606.863 266.425 605.719 266.107 605.192 265.182C604.674 264.246 604.983 263.064 605.878 262.519C606.784 261.974 607.938 262.293 608.455 263.228Z",
    fill: "#E0DEF6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M561.77 214.944C562.675 215.478 562.984 216.671 562.456 217.606C561.929 218.542 560.785 218.861 559.879 218.316C558.974 217.781 558.665 216.589 559.193 215.653C559.72 214.718 560.874 214.399 561.77 214.944Z",
    fill: "#E0DEF6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M620.226 249.803C621.132 250.338 621.44 251.53 620.913 252.466C620.395 253.401 619.241 253.72 618.336 253.175C617.43 252.641 617.122 251.448 617.649 250.513C618.176 249.587 619.331 249.269 620.226 249.803Z",
    fill: "#E0DEF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M556.427 232.101C557.471 232.101 558.307 232.974 558.307 234.043C558.307 235.113 557.462 235.986 556.427 235.986C555.382 235.986 554.546 235.113 554.546 234.043C554.546 232.974 555.382 232.101 556.427 232.101Z",
    fill: "#E0DEF6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M623.928 232.101C624.972 232.101 625.808 232.974 625.808 234.043C625.808 235.113 624.962 235.986 623.928 235.986C622.883 235.986 622.047 235.113 622.047 234.043C622.047 232.974 622.883 232.101 623.928 232.101Z",
    fill: "#E0DEF6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M560.108 249.731C561.014 249.196 562.158 249.515 562.685 250.44C563.203 251.376 562.894 252.558 561.999 253.103C561.093 253.637 559.949 253.319 559.422 252.394C558.894 251.458 559.203 250.266 560.108 249.731Z",
    fill: "#E0DEF6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M618.555 214.862C619.46 214.327 620.604 214.646 621.132 215.571C621.649 216.507 621.341 217.689 620.445 218.234C619.54 218.768 618.395 218.45 617.868 217.524C617.351 216.599 617.659 215.407 618.555 214.862Z",
    fill: "#E0DEF6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M571.819 263.096C572.337 262.16 573.491 261.841 574.396 262.386C575.302 262.921 575.61 264.113 575.083 265.049C574.566 265.984 573.411 266.303 572.506 265.758C571.61 265.224 571.302 264.031 571.819 263.096Z",
    fill: "#E0DEF6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M605.57 202.711C606.087 201.775 607.241 201.457 608.147 202.001C609.052 202.536 609.361 203.729 608.833 204.664C608.316 205.6 607.162 205.918 606.256 205.373C605.351 204.828 605.042 203.636 605.57 202.711Z",
    fill: "#E0DEF6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M590.177 203.677V233.91L573.083 245.249",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M590.177 237.189C591.93 237.189 593.351 235.721 593.351 233.91C593.351 232.099 591.93 230.631 590.177 230.631C588.424 230.631 587.003 232.099 587.003 233.91C587.003 235.721 588.424 237.189 590.177 237.189Z",
    fill: "#E0DEF6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M561.641 228.627H484.707V324.776H561.641V228.627Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 240.994H518.696",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 247.83H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 254.677H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 261.523H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 268.359H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 275.206H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 282.042H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 288.889H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 295.735H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 302.571H550.885",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M495.473 309.418H518.696",
    stroke: "#D0CDF1",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M544.119 224.001V247.635C544.119 250.585 541.8 252.98 538.945 252.98C536.089 252.98 533.771 250.585 533.771 247.635V222.983C533.771 218.47 537.313 214.811 541.681 214.811C546.049 214.811 549.591 218.47 549.591 222.983V228.627",
    stroke: "#6258D1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M285.647 200.871L308.005 203.173C309.448 188.154 302.801 172.868 289.588 164.284L277.638 183.919C283.399 187.661 286.274 194.322 285.647 200.871Z",
    fill: "#E0DEF6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M283.09 208.632C277.996 217.01 267.29 219.529 259.18 214.265C257.26 213.011 255.658 211.428 254.404 209.639L236.256 223.302C239.151 227.403 242.823 231.032 247.24 233.9C265.847 245.979 290.413 240.192 302.105 220.968C305.498 215.396 307.428 209.3 308.015 203.163L285.657 200.86C285.399 203.543 284.573 206.196 283.09 208.632Z",
    fill: "#6258D1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M236.246 223.301L254.394 209.639C252.852 207.45 251.837 204.951 251.37 202.33L229.281 206.524C230.345 212.538 232.703 218.285 236.246 223.301Z",
    fill: "#918ADF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M253.718 189.553C257.519 183.302 264.434 180.321 271.071 181.38L274.533 158.456C259.31 156.009 243.43 162.866 234.703 177.206C229.181 186.283 227.519 196.738 229.261 206.515L251.35 202.32C250.604 198.064 251.31 193.51 253.718 189.553Z",
    fill: "#D0CDF1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M271.081 181.39C273.339 181.75 275.578 182.583 277.638 183.919L289.588 164.284C284.851 161.211 279.737 159.299 274.543 158.466L271.081 181.39Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M258.096 354.084H172.237V471.317H258.096V354.084Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 420.605H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 426.969H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 433.332H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 439.686H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 446.049H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M179.481 452.412H250.842",
    stroke: "#E0DEF6",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M194.595 367.387H179.481V376.228H194.595V367.387Z",
    fill: "#E0DEF6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M213.341 367.387H198.227V376.228H213.341V367.387Z",
    fill: "#E0DEF6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M232.097 367.387H216.983V376.228H232.097V367.387Z",
    fill: "#B8D0FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M250.842 367.387H235.728V376.228H250.842V367.387Z",
    fill: "#B8D0FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M194.595 379.65H179.481V388.491H194.595V379.65Z",
    fill: "#E0DEF6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M213.341 379.65H198.227V388.491H213.341V379.65Z",
    fill: "#E0DEF6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M232.097 379.65H216.983V388.491H232.097V379.65Z",
    fill: "#E0DEF6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M250.842 379.65H235.728V388.491H250.842V379.65Z",
    fill: "#B8D0FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M194.595 391.904H179.481V400.745H194.595V391.904Z",
    fill: "#E0DEF6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M213.341 391.904H198.227V400.745H213.341V391.904Z",
    fill: "#E0DEF6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M232.097 391.904H216.983V400.745H232.097V391.904Z",
    fill: "#E0DEF6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M250.842 391.904H235.728V400.745H250.842V391.904Z",
    fill: "#E0DEF6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M194.595 404.158H179.481V412.999H194.595V404.158Z",
    fill: "#E0DEF6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M213.341 404.158H198.227V412.999H213.341V404.158Z",
    fill: "#E0DEF6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M232.097 404.158H216.983V412.999H232.097V404.158Z",
    fill: "#E0DEF6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M250.842 404.158H235.728V412.999H250.842V404.158Z",
    fill: "#E0DEF6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M316.701 309.109H193.908V313.92H316.701V309.109Z",
    fill: "#D0CDF1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M271.081 313.92H182.426L169.879 252.939H258.524L271.081 313.92Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M255.608 254.327L267.877 313.92",
    stroke: "#D0CDF1",
    strokeWidth: 0.8758,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M228.236 282.721C229.221 287.532 225.729 291.428 220.425 291.428C215.122 291.428 210.017 287.532 209.032 282.721C208.047 277.91 211.54 274.014 216.843 274.014C222.147 274.024 227.251 277.92 228.236 282.721Z",
    stroke: "#D0CDF1",
    strokeWidth: 0.759,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M205.57 204.993H153.382C147.731 204.993 143.154 209.722 143.154 215.561V239.616C143.154 245.455 147.731 250.184 153.382 250.184H167.402C170.267 250.184 172.775 252.178 173.511 255.036L179.481 278.29L185.451 255.036C186.187 252.178 188.695 250.184 191.56 250.184H205.58C211.231 250.184 215.808 245.455 215.808 239.616V215.561C215.799 209.722 211.222 204.993 205.57 204.993Z",
    fill: "#E0DEF6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M199.301 216.271H162.267V241.642H199.301V216.271Z",
    stroke: "white",
    strokeWidth: 0.8758,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M164.914 218.953L180.794 231.33L196.675 218.953",
    stroke: "white",
    strokeWidth: 0.8758,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M183.929 228.884L196.675 238.968",
    stroke: "white",
    strokeWidth: 0.8758,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M164.914 238.968L177.75 228.955",
    stroke: "white",
    strokeWidth: 0.8758,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M170.317 216.271C170.317 220.311 167.143 223.59 163.233 223.59C159.312 223.59 156.148 220.311 156.148 216.271C156.148 212.22 159.322 208.951 163.233 208.951C167.143 208.951 170.317 212.23 170.317 216.271Z",
    fill: "#6258D1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 215.551L162.337 218.553L167.501 213.999",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M472.101 177.771L477.464 208.437H526.676L521.313 177.771H472.101Z",
    fill: "#918ADF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M526.089 168.057H477.623V208.436H526.089V168.057Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M507.99 173.402L502.707 180.269H482.26L477.623 208.437H526.836L532.597 173.402H507.99Z",
    fill: "#E0DEF6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M159.64 332.894C163.992 328.398 163.992 321.108 159.64 316.612C155.288 312.115 148.232 312.115 143.88 316.612C139.528 321.108 139.528 328.398 143.88 332.894C148.232 337.39 155.288 337.39 159.64 332.894Z",
    fill: "#6258D1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M562.475 171.745C563.883 165.555 560.167 159.358 554.175 157.904C548.184 156.449 542.185 160.289 540.778 166.479C539.37 172.669 543.086 178.866 549.078 180.321C555.069 181.775 561.068 177.936 562.475 171.745Z",
    fill: "#6258D1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M634.795 398.98C636.216 392.793 632.513 386.587 626.525 385.119C620.536 383.651 614.529 387.476 613.108 393.663C611.687 399.851 615.39 406.056 621.378 407.525C627.367 408.993 633.374 405.168 634.795 398.98Z",
    fill: "#6258D1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M298.201 271.134C302.553 266.638 302.553 259.348 298.201 254.852C293.849 250.356 286.793 250.356 282.441 254.852C278.089 259.348 278.089 266.638 282.441 271.134C286.793 275.631 293.849 275.631 298.201 271.134Z",
    fill: "#6258D1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M397.417 558.904C402.232 554.943 403.026 547.699 399.192 542.725C395.357 537.752 388.346 536.931 383.532 540.892C378.718 544.854 377.923 552.098 381.758 557.071C385.592 562.045 392.603 562.866 397.417 558.904Z",
    fill: "#6258D1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M389.028 284.334C426.599 284.334 457.056 252.867 457.056 214.05C457.056 175.233 426.599 143.766 389.028 143.766C351.457 143.766 321 175.233 321 214.05C321 252.867 351.457 284.334 389.028 284.334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M431.154 257.58C454.422 233.541 454.422 194.566 431.154 170.527C407.887 146.488 370.163 146.488 346.895 170.527C323.628 194.566 323.628 233.541 346.895 257.58C370.163 281.62 407.887 281.62 431.154 257.58Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M389.008 370.634L274.633 394.37L389.008 468.674L503.373 394.37L389.008 370.634Z",
    fill: "#141D30"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M445.255 373.143L441.156 364.446L463.165 263.661L406.082 245.928H389.008H371.934L314.851 263.661L336.86 364.446L332.761 373.143L310.005 386.034L362.999 425.149C370.869 430.012 381.058 425.766 383.456 416.617L389.018 395.461L394.58 416.617C396.978 425.756 407.167 430.001 415.037 425.149L468.031 386.034L445.255 373.143Z",
    fill: "#26395E"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M371.964 248.271H406.042L389.008 333.431L371.964 248.271Z",
    fill: "#DEDEDE"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M372.362 250.234L395.048 331.703L384.799 338.848L372.362 250.234Z",
    fill: "#ABABAB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M432.231 276.768C432.231 276.768 421.555 257.071 406.042 248.271L389.008 333.441L371.974 248.271C356.462 257.071 345.785 276.768 345.785 276.768L361.178 286.02L345.785 285.732C345.785 285.732 359.506 317.795 392.66 348.07C401.067 338.242 421.883 312.347 432.231 285.732L416.838 286.02L432.231 276.768Z",
    fill: "#141D30"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M373.277 241.641H404.659L388.968 257.061L373.277 241.641Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M406.042 213.638C406.042 213.638 408.003 206.123 409.396 199.565C410.799 193.016 407.714 189.932 405.296 188.771C403.197 177.062 395.436 172.189 387.784 172.179C387.108 172.179 386.829 173.094 387.396 173.484C390.292 175.448 391.486 178.264 391.486 178.264C391.486 178.264 381.595 175.859 371.894 181.739C362.193 187.619 363.964 191.957 368.531 194.651C368.531 194.651 368.909 203.995 371.426 213.35L406.042 213.638Z",
    fill: "#142F61"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M389.008 333.431C391.675 347.309 397.416 362.348 397.416 362.348L389.724 392.9",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M389.107 365.33C390.833 365.33 392.232 363.885 392.232 362.102C392.232 360.319 390.833 358.874 389.107 358.874C387.382 358.874 385.983 360.319 385.983 362.102C385.983 363.885 387.382 365.33 389.107 365.33Z",
    fill: "#DEDEDE"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M385.844 391.143C385.844 392.921 384.441 394.371 382.72 394.371C380.998 394.371 379.595 392.921 379.595 391.143C379.595 389.365 380.998 387.915 382.72 387.915C384.441 387.915 385.844 389.365 385.844 391.143Z",
    fill: "#DEDEDE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M375.725 343.649L390.739 357.332",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M387.476 367.067L376.839 374.202",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M370.09 382.16L341.233 374.268L340.184 378.362L369.04 386.254L370.09 382.16Z",
    fill: "#D0CDF1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M408.983 386.262L437.839 378.37L436.79 374.276L407.934 382.168L408.983 386.262Z",
    fill: "#D0CDF1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M431.773 478.02L453.384 490.736L449.265 517.567L421.913 500.749L431.773 478.02Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M446.708 485.503L448.131 506.679L443.136 502.65L433.196 511.552L443.832 518.81L452.111 541.354L455.753 555.304C456.24 557.154 458.469 557.771 459.792 556.424C462.837 553.34 467.086 547.368 467.424 537.91C467.961 522.531 464.897 510.062 464.897 510.062L468.787 510.73L470.23 492.627L466.101 492.329C466.091 492.329 458.539 484.115 446.708 485.503Z",
    fill: "#141D30"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M249.529 416.524C253.628 394.597 282.732 385.643 310.343 400.95C337.955 416.257 438.32 473.918 438.32 473.918L421.346 519.787C410.391 515.983 409.266 510.771 400.5 507.451C393.267 504.706 391.127 508.181 379.655 504.131C368.183 500.08 364.441 495.66 357.825 493.285C347.327 489.523 337.566 490.602 327.845 487.189C311.458 481.453 297.359 476.488 290.195 473.907C261.121 463.453 245.42 438.452 249.529 416.524Z",
    fill: "#26395E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M413.137 509.671L423.236 465.262C426.48 467.122 429.315 468.747 431.614 470.073L413.137 509.671Z",
    fill: "#141D30"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M431.624 479.315L326.681 410.12",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M465.474 494.23L464.26 507.646",
    stroke: "#496EB5",
    strokeWidth: 0.6883,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M421.355 519.797C416.659 518.163 413.764 516.271 411.306 514.38L429.196 468.675C434.927 471.964 438.34 473.918 438.34 473.918L421.355 519.797Z",
    fill: "#496EB5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M468.976 508.201L470.22 492.616L466.091 492.318C466.091 492.318 458.539 484.105 446.708 485.492L446.798 486.86L435.902 480.445L438.32 473.907C438.32 473.907 406.311 455.516 373.476 436.755L307.537 480.064C313.567 482.182 320.462 484.608 327.845 487.189C337.566 490.591 347.327 489.522 357.825 493.285C364.431 495.649 368.183 500.08 379.655 504.13C391.127 508.18 393.277 504.706 400.5 507.45C409.266 510.781 410.401 515.983 421.346 519.786L427.196 503.986L435.753 509.249L433.186 511.542L443.823 518.799L444.111 519.581L464.887 510.072V510.062H464.907L468.976 508.201Z",
    fill: "#141D30"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M528.477 416.524C524.378 394.597 495.274 385.643 467.663 400.95C440.051 416.257 339.686 473.918 339.686 473.918L356.661 519.787C367.615 515.983 368.74 510.771 377.506 507.451C384.739 504.706 386.879 508.181 398.351 504.131C409.823 500.08 413.565 495.66 420.181 493.285C430.679 489.523 440.44 490.602 450.161 487.189C466.548 481.453 480.647 476.488 487.811 473.907C516.895 463.453 532.586 438.452 528.477 416.524Z",
    fill: "#26395E"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M364.869 509.671L354.77 465.262C351.526 467.122 348.691 468.747 346.392 470.073L364.869 509.671Z",
    fill: "#141D30"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M346.382 479.315L451.325 410.12",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M346.233 478.02L324.622 490.736L328.741 517.567L356.093 500.749L346.233 478.02Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M331.298 485.503L329.875 506.679L334.87 502.65L344.81 511.552L334.173 518.81L325.895 541.354L322.253 555.304C321.766 557.154 319.537 557.771 318.214 556.424C315.169 553.34 310.92 547.368 310.582 537.91C310.045 522.531 313.109 510.062 313.109 510.062L309.219 510.73L307.776 492.627L311.905 492.329C311.915 492.329 319.467 484.115 331.298 485.503Z",
    fill: "#141D30"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M312.532 494.23L313.746 507.646",
    stroke: "#496EB5",
    strokeWidth: 0.6883,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M356.651 519.797C361.347 518.163 364.242 516.271 366.7 514.38L348.81 468.675C343.079 471.964 339.666 473.918 339.666 473.918L356.651 519.797Z",
    fill: "#D0CDF1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M215.928 363.788C210.226 360.56 221.987 332.177 221.987 332.177L231.888 336.587C231.888 336.597 221.669 367.046 215.928 363.788Z",
    fill: "#ABABAB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M236.037 338.437L214.326 328.773C214.326 328.773 215.719 322.225 210.684 317.28C207.818 314.464 204.177 311.698 204.177 311.698L201.948 313.836L205.799 318.565L205.679 324.548L195.152 324.579L182.914 320.673L182.008 323.705L180.605 322.986L179.063 327.396L181.66 328.989L180.456 332.166L185.769 336.144L191.65 337.45L185.003 337.522L181.222 335.137L180.456 337.522L185.212 340.338C185.212 340.338 195.918 344.697 208.017 341.716L227.818 359.017L236.037 338.437Z",
    fill: "#FF8C8C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M227.828 359.007L236.037 338.437L219.152 330.922C220.614 336.956 220.594 343.782 219.569 351.801L227.828 359.007Z",
    fill: "#D45151"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M217.888 380.276C212.923 377.48 220.564 362.143 220.564 362.143L236.683 369.256C236.693 369.246 223.36 383.35 217.888 380.276Z",
    fill: "#141D30"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M239.718 339.507L227.689 334.634C227.689 334.634 224.236 360.611 215.938 363.798L239.718 379.259V339.507Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M299 398.194C299.577 397.557 299.916 396.951 300.065 396.354C278.424 388.922 257.887 395.573 251.26 410.849C264.165 420.996 288.682 409.616 299 398.194Z",
    fill: "#141D30"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M314.841 263.66L329.398 330.295L311.348 381.099C303.995 401.782 281.021 411.445 261.777 401.947L217.898 380.276C217.898 380.276 228.534 383.165 239.728 339.506L269.668 352.808L302.125 289.494C302.125 289.484 302.105 278.309 314.841 263.66Z",
    fill: "#26395E"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M229.659 368.383L261.638 384.605",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M240.136 368.126C241.334 368.126 242.305 367.122 242.305 365.885C242.305 364.647 241.334 363.644 240.136 363.644C238.938 363.644 237.967 364.647 237.967 365.885C237.967 367.122 238.938 368.126 240.136 368.126Z",
    fill: "#DEDEDE"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M254.832 372.875C254.832 374.108 253.857 375.116 252.663 375.116C251.469 375.116 250.494 374.108 250.494 372.875C250.494 371.641 251.469 370.634 252.663 370.634C253.867 370.634 254.832 371.641 254.832 372.875Z",
    fill: "#DEDEDE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M269.658 352.809L288.881 361.67",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M274.633 351.935L294.423 352.808",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M319.358 284.333C318.074 288.692 315.119 301.665 317.756 321.937C318.084 324.446 317.905 327.016 317.119 329.411C312.522 343.587 315.865 356.92 317.856 362.769L329.398 330.285L319.358 284.333Z",
    fill: "#141D30"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M181.998 323.716L194.247 328.229L198.535 328.619",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M181.66 328.989L189.859 332.711L197.092 333.389",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M199.142 326.841L196.525 336.278",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M198.535 335.353C201.242 333.194 206.227 330.789 210.804 333.914",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M562.078 363.788C567.78 360.56 556.019 332.177 556.019 332.177L546.118 336.587C546.118 336.597 556.347 367.046 562.078 363.788Z",
    fill: "#ABABAB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M541.979 338.437L563.69 328.773C563.69 328.773 562.297 322.225 567.332 317.28C570.198 314.464 573.839 311.698 573.839 311.698L576.068 313.836L572.217 318.565L572.337 324.548L582.864 324.579L595.102 320.673L596.008 323.705L597.411 322.986L598.953 327.396L596.356 328.989L597.56 332.166L592.247 336.144L586.366 337.45L593.013 337.522L596.794 335.137L597.56 337.522L592.804 340.338C592.804 340.338 582.098 344.697 569.999 341.716L550.198 359.017L541.979 338.437Z",
    fill: "#FF8C8C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M550.188 359.007L541.979 338.437L558.864 330.922C557.402 336.956 557.422 343.782 558.437 351.801L550.188 359.007Z",
    fill: "#D45151"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M560.118 380.276C565.083 377.48 557.442 362.143 557.442 362.143L541.323 369.256C541.323 369.246 554.656 383.35 560.118 380.276Z",
    fill: "#141D30"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M538.298 339.507L550.327 334.634C550.327 334.634 553.78 360.611 562.078 363.798L538.288 379.269V339.507H538.298Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M479.016 398.194C478.439 397.557 478.1 396.951 477.951 396.354C499.592 388.922 520.129 395.573 526.756 410.849C513.851 420.996 489.334 409.616 479.016 398.194Z",
    fill: "#141D30"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M463.165 263.66L448.609 330.295L466.658 381.099C474.011 401.782 496.985 411.445 516.229 401.947L560.108 380.276C560.108 380.276 549.472 383.165 538.278 339.506L508.338 352.808L475.881 289.494C475.891 289.484 475.911 278.309 463.165 263.66Z",
    fill: "#26395E"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M548.357 368.383L516.378 384.605",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M537.88 368.126C539.078 368.126 540.049 367.122 540.049 365.885C540.049 364.647 539.078 363.644 537.88 363.644C536.682 363.644 535.711 364.647 535.711 365.885C535.711 367.122 536.682 368.126 537.88 368.126Z",
    fill: "#DEDEDE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M523.174 372.875C523.174 374.108 524.149 375.116 525.343 375.116C526.537 375.116 527.512 374.108 527.512 372.875C527.512 371.641 526.537 370.634 525.343 370.634C524.149 370.634 523.174 371.641 523.174 372.875Z",
    fill: "#DEDEDE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M508.348 352.809L489.135 361.67",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M503.383 351.935L483.583 352.808",
    stroke: "#141D30",
    strokeWidth: 0.7631,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M458.658 284.333C459.941 288.692 462.896 301.665 460.26 321.937C459.931 324.446 460.11 327.016 460.896 329.411C465.493 343.587 462.15 356.92 460.16 362.769L448.618 330.285L458.658 284.333Z",
    fill: "#141D30"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M596.008 323.716L583.769 328.229L579.481 328.619",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M596.356 328.989L588.157 332.711L580.924 333.389",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M578.874 326.841L581.481 336.278",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M579.481 335.353C576.774 333.194 571.79 330.789 567.213 333.914",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M400.63 223.178H388.968H377.307L376.093 245.732L388.968 253.545L401.843 245.732L400.63 223.178Z",
    fill: "#FF8C8C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M392.093 259.898H385.844L382.889 249.536H395.048L392.093 259.898Z",
    fill: "#2960CD"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M393.396 238.876C395.396 238.876 398.311 238.382 401.366 236.984L400.62 223.188H388.968H377.307L376.939 230.045C381.983 236.974 389.476 238.876 393.396 238.876Z",
    fill: "#D45151"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M373.938 220.144C376.403 218.826 377.205 215.371 375.73 212.426C374.255 209.481 371.062 208.163 368.597 209.48C366.132 210.798 365.33 214.253 366.805 217.198C368.28 220.143 371.474 221.461 373.938 220.144Z",
    fill: "#D45151"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M368.411 213.957C369.118 210.75 372.491 210.431 375.297 214.121",
    stroke: "#FF8C8C",
    strokeWidth: 0.7091,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M402.192 212.435C400.719 215.375 401.525 218.83 403.993 220.156C406.46 221.482 409.654 220.156 411.127 217.216C412.6 214.276 411.794 210.821 409.326 209.495C406.858 208.169 403.674 209.495 402.192 212.435Z",
    fill: "#D45151"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M409.525 213.957C408.819 210.75 405.445 210.431 402.64 214.121",
    stroke: "#FF8C8C",
    strokeWidth: 0.7091,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M404.659 205.948C402.62 203.553 401.714 200.356 402.182 197.2C402.381 195.863 401.376 194.65 400.062 194.65H388.968H377.864C376.551 194.65 375.546 195.863 375.745 197.2C376.212 200.346 375.307 203.553 373.267 205.948L371.884 207.572C372.819 227.618 384.202 232.049 388.958 232.049C393.714 232.049 405.097 227.618 406.032 207.572L404.659 205.948Z",
    fill: "#FF8C8C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M378.57 208.344C380.063 210.369 383.277 210.318 385.376 208.148",
    stroke: "#142F61",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M377.456 203.615C380.113 202.124 383.098 201.877 385.754 203.615",
    stroke: "#142F61",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M399.366 208.344C397.873 210.369 394.66 210.318 392.56 208.148",
    stroke: "#142F61",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M400.48 203.615C397.824 202.124 394.839 201.877 392.182 203.615",
    stroke: "#142F61",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M388.172 206.072V213.484L391.426 212.795",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M383.396 215.869C383.396 215.869 387.784 219.005 394.54 215.869",
    stroke: "#142F61",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M387.038 220.382H390.899",
    stroke: "#D45151",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M387.456 249.536L383.297 258.736L369.794 248.24L373.277 241.641L387.456 249.536Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M390.481 249.536L394.64 258.736L408.142 248.24L404.659 241.641L390.481 249.536Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M392.093 259.897H385.844C385.844 259.897 386.361 277.435 391.296 286.687C400.122 303.197 419.564 299.794 424.5 307.412C429.445 315.029 434.758 326.687 458.27 323.119L472.638 308.563L457.713 301.429C457.713 301.429 447.544 305.859 440.828 297.954C434.111 290.049 428.33 287.551 418.908 287.838C409.485 288.137 394.003 282.74 392.093 259.897Z",
    fill: "#2960CD"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M393.028 266.086C392.6 264.184 392.282 262.128 392.103 259.897H385.854C385.854 259.897 385.864 260.103 385.874 260.463C387.973 261.758 390.958 263.804 393.028 266.086Z",
    fill: "#16346F"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M767.97 654H490C490.38 613.545 535.56 574.512 587.87 574.702C589.87 538.753 624.99 504.505 671.49 516.518C687.18 481.269 725.86 454.159 767.97 455.02V654Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M767.97 654H548.5C549.06 631.475 582.9 609.181 619.97 609.181C635.75 572.25 667.19 562.209 707.69 569.527C721.8 538.452 751.99 534.568 767.97 534.848V654Z",
    fill: "#E0DEF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 384,
    y1: 0,
    x2: 384,
    y2: 654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEF1FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 277.97,
    height: 198.78,
    fill: "white",
    transform: "translate(0 455)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetstarted);
export default __webpack_public_path__ + "static/media/getstarted.b54a7860.svg";
export { ForwardRef as ReactComponent };